import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../typography';
export function ModalHeading({ children }) {
    return (_jsx(Text, { type: "h2", as: "h1", children: children }));
}
